import { API } from "@swivl-mono/api-helper";
import { TenantInterface } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";

interface StoreInterface {
  tenants?: TenantInterface[];
  isLoading: boolean;
  broadcastTenants?: TenantInterface[];
  isBroadcastTenantsLoading: boolean;
}
const BlankState: StoreInterface = {
  tenants: undefined,
  isLoading: true,
  broadcastTenants: undefined,
  isBroadcastTenantsLoading: true
};
export default class TenantsModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = TenantsModel.useState.setState;
  static get state() {
    return TenantsModel.useState.getState();
  }
  static reset() {
    TenantsModel.setState({ ...BlankState });
  }

  static async getTenantsByUserId(userId: number) {
    TenantsModel.setState({ isLoading: true });
    const tenants = await API.Tenants.getTenantsByUserId(Member.orgId!, userId);
    TenantsModel.setState({ isLoading: false, tenants: tenants });
  }

  static async getUniqueBroadcastTenantsBy(locationIds: number[], where?: Partial<TenantInterface>, includeUser?: boolean) {
    TenantsModel.setState({ isBroadcastTenantsLoading: true });
    const tenants = await API.Tenants.getUniqueTenantsByPhone(Member.orgId!, locationIds, where, includeUser);
    TenantsModel.setState({ isBroadcastTenantsLoading: false, broadcastTenants: tenants });
  }
}
